import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Referral from '../../entities/referral';
export function deleteReferral(referral: Referral, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = referral.id;}
const _work = workingSet();




referral.status = 'D';
referral.addedOn = newHRTimestamp();
referral.addedBy = getCurrentUserId();
referral.importSource = targetImportSource;
referral.importId = mergeId;
store.dispatch(Actions.ReferralActions.removeReferralQueue(referral));
}


